import { render, staticRenderFns } from "./edir-user.vue?vue&type=template&id=68bc9f13&scoped=true"
import script from "./edir-user.vue?vue&type=script&lang=js"
export * from "./edir-user.vue?vue&type=script&lang=js"
import style0 from "./edir-user.vue?vue&type=style&index=0&id=68bc9f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc9f13",
  null
  
)

export default component.exports